import { get } from "nodash"
import { useTranslation as useTranslationOriginal } from "next-i18next"
import { useCallback } from "react"

// ***********************************************************
// DEPRECATED edit @nova/use-translation instead of this file
// ***********************************************************

// the pluralizer gets weird with zero or 0, so we bypass all those issues by making our own map
const countContextMap = ["none", "single", "plural"]

export type TranslateCountFunction = (
    label: string,
    options: { count: number; hiddenCount?: number }
) => string
export type TranslateFunction = (
    label: string,
    options?: Record<string, number | Namespace>
) => string
type Namespace = string | string[] | readonly string[] | undefined

export const useTranslation = (ns?: Namespace) => {
    const tools = useTranslationOriginal(ns)
    const { t } = tools

    // a convenience helper to standardize the count-context logic
    const tc = useCallback(
        (label: string, options: { count: number; hiddenCount?: number }): string => {
            const { count, hiddenCount } = options
            const context = get(countContextMap, `${count}`, countContextMap.at(-1))

            const key = hiddenCount && hiddenCount > 0 ? label + "_hidden" : label
            const result = t(key, { ...options, context })
            return result
        },
        [t]
    )

    return {
        ...tools,
        t: t as TranslateFunction,
        tc: tc as TranslateCountFunction,
    }
}
export default useTranslation
